import React from 'react'

export const formatLicenseContent = (licenseContent) => {

    if(! licenseContent)
    {
        return '';
    }

    return licenseContent
        .split("\n")
        .map(function(textitem, index)
        {
            if(textitem.indexOf("-") === 0) return <span key={index}>{textitem}<br /></span>

            return <p key={index}>{ textitem }</p>
        })
}
